import ButtonMsPay from './ButtonMsPay'

export default ButtonMsPay
